import React from 'react'
import { DataTool } from '@ztechapps/webui.data-tools'
import { useProductSelectListContext } from './Context'
import { Stack } from 'react-bootstrap'

export const Toolbox = () => {
  const { productList, listFieldConfig } = useProductSelectListContext()

  return (
    <Stack gap={2}>
      <DataTool
        fieldsConfig={listFieldConfig}
        {...{
          searchPlaceHolder: 'Search product',
          filterCategory: 'product-select-list',
          ...productList,
          components: {
            filter: () => null,
            sort: () => null,
          },
        }}
      />
    </Stack>
  )
}
